/** True when there is no expiry, the timestamp has passed, or the expiry date is today. */
export const isSubscriptionExpired = (expiresOn) => {
  if (expiresOn == null || expiresOn === "") return true;
  const expires = new Date(expiresOn);
  if (Number.isNaN(expires.getTime())) return true;
  if (expires.getTime() <= Date.now()) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const day = new Date(expires);
  day.setHours(0, 0, 0, 0);
  return day.getTime() <= today.getTime();
};
